import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Cards from "./pages/Cards";
import Locations from "./pages/Locations";
import Location from "./pages/Location";
import Navbar from "./components/Navbar";
import User from "./pages/User"
import Card from "./pages/Card";
import Offer from "./pages/Offer";

function PrivateRoute({ children }) {
    const { token } = useAuth();
    return token ? children : <Navigate to="/login" replace />;
}

function Layout() {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/:id" element={<User/>} />
                <Route path="/cards" element={<Cards />} />
                <Route path="/cards/:id" element={<Card/>} />
                <Route path="/locations" element={<Locations />} />
                <Route path="/locations/:id" element={<Location/>} />
                <Route path="/offers/:id" element={<Offer/>}/>
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/*"
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
